module.exports = __webpack_public_path__ + "img/brand_6.9364f857.png";